
































































import {Component, Vue} from "vue-property-decorator";
import EForm from "@/components/datatable/EForm.vue";

class seoConfig {
    siteTitle: string = "";
    metaDescription: string = "";
    ogImage: string = "";
    canonicalBase: string = "";
    robotsTxt: string = "";
    ga4Id: string = "";
    gtmId: string = "";
    googleSiteVerification: string = "";
    og_file: File | null = null;
}

@Component({
    components: {EForm}
})
export default class TeknikSeo extends Vue {
    action: string = "config/seo";
    data: seoConfig = new seoConfig();

    get canonicalBase() {
        if (this.data.canonicalBase) {
            return this.data.canonicalBase;
        }
        let site = this.$store.getters.activeSite;
        if (site && site.domain) {
            return "https://" + String(site.domain).replace(/^https?:\/\//, "") + "/";
        }
        return this.$store.state.siteUrl;
    }

    onOgFile(event: any) {
        const files = event.target.files;
        this.data.og_file = files && files.length > 0 ? files[0] : null;
    }

    async get() {
        let response = await this.$http.get(this.action);
        let fresh = new seoConfig();
        Object.keys(fresh).forEach((key: string) => {
            if (key !== "og_file" && response.data && typeof response.data[key] !== "undefined") {
                (fresh as any)[key] = response.data[key];
            }
        });
        this.data = fresh;
    }

    created() {
        this.get();
    }
}
